<template>
  <div class="video-page-wrapper">
    <IphoneVideo :video-name="require('@/assets/videos/user_permissions.mp4')"></IphoneVideo>
    <div class="video-page-texts">
      <div>
        <h3>{{ $t("pages.user-management.subtitle1") }}</h3>
        <p>{{ $t("pages.user-management.text1") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserManagement"
};
</script>

<style scoped lang="scss">
</style>
